import { render, staticRenderFns } from "./PRO_Trending.vue?vue&type=template&id=7b832328&scoped=true&"
import script from "./PRO_Trending.vue?vue&type=script&lang=js&"
export * from "./PRO_Trending.vue?vue&type=script&lang=js&"
import style0 from "./PRO_Trending.vue?vue&type=style&index=0&id=7b832328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b832328",
  null
  
)

export default component.exports